module.exports = {"340172001":"莲花社区管理委员会","340172002":"芙蓉社区管理委员会","340172003":"锦绣社区管理委员会","340172004":"海恒社区管理委员会","340172005":"临湖社区管理委员会","340172100":"高刘镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340172.json
// module id = 1044
// module chunks = 0